import {fetchBody} from "../../config"
import { toLogout, cleanFetch } from "../apiTools";
import { getToken } from "../../component/Login/Auth";
import { URL_PARK_ADD, URL_PARK_GET_LIST, URL_PARK_GET_DETAIL, URL_PARK_EDIT, URL_PARK_CHECK_NAME, URL_PARK_GET_LIST_ENABLE } from "../../setup/config_mystat";

export function api_getParkList ({mReqParkList, success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: mReqParkList, token}), 
      url: URL_PARK_GET_LIST, 
      success:(jsonDate)=>{
        success(jsonDate)
      },
      failure:(error)=>{
        failure(error)
      }
    })
  }
}

export function api_getParkListEnable ({success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({token}), 
      url: URL_PARK_GET_LIST_ENABLE, 
      success:(jsonDate)=>{
        success(jsonDate)
      },
      failure:(error)=>{
        failure(error)
      }
    })
  }
}

export function api_addPark ({isAdd=true, mRespPark, success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    console.log(mRespPark)
    cleanFetch({
      body: fetchBody({body: mRespPark, token}), 
      url: isAdd?URL_PARK_ADD:URL_PARK_EDIT, 
      success:(jsonDate)=>{
        success(jsonDate)
      },
      failure:(error)=>{
        failure(error)
      }
    })
  }
}

export function api_getParkDetail ({mReqParkDetail, success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: mReqParkDetail, token}), 
      url: URL_PARK_GET_DETAIL, 
      success:(jsonDate)=>{
        success(jsonDate)
      },
      failure:(error)=>{
        failure(error)
      }
    })
  }
}

export function api_checkParkName ({mRespPark, success, failure}){
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: mRespPark, token}), 
      url: URL_PARK_CHECK_NAME, 
      success:(jsonDate)=>{
        success(jsonDate)
      },
      failure:(error)=>{
        failure(error)
      }
    })
  }
}